var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.visible)?_c('div',{staticClass:"TRC-AppLoadingOverlay"},[_c('div',{staticClass:"TRC-AppLoadingOverlay__Content"},[_c('app-spinner',{class:{
              'TRC-AppLoadingOverlay__Spinner': _vm.isApplicableForCheckoutRedirect
          },attrs:{"size":"50","message":_vm.isApplicableForCheckoutRedirect ? 'You are now being redirected to the checkout' : ''}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }